module.exports = __webpack_public_path__ + "static/img/ls21.7414647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls21.png
// module id = wfg+
// module chunks = 12